import { DashboardSectionId } from "../../types.js";

const NAV_ITEMS: Array<{
  id: DashboardSectionId;
  label: string;
  icon: string;
}> = [
  { id: "assets", label: "Assets", icon: "inventory_2" },
  { id: "projects", label: "Projects", icon: "folder" },
  { id: "messages", label: "Team", icon: "chat_bubble" },
  { id: "settings", label: "Setup", icon: "settings" },
];

export function DashboardMobileBottomNav({
  activeSection,
  onNavigate,
}: {
  activeSection: DashboardSectionId;
  onNavigate: (sectionId: DashboardSectionId) => void;
}) {
  return (
    <nav
      className="fixed inset-x-0 bottom-0 z-50 flex items-center justify-around border-t border-black/10 dark:border-white/10 bg-white dark:bg-slate-950/95 px-4 py-3 pb-4 backdrop-blur-xl lg:hidden"
      data-oid="314dfj:"
    >
      {NAV_ITEMS.map((item) => (
        <button
          className={`flex flex-1 flex-col items-center gap-1 rounded-2xl px-3 py-2 text-xs font-semibold uppercase tracking-[0.14em] transition-colors ${
            activeSection === item.id
              ? "bg-sky-500/10 text-sky-600 dark:text-sky-300"
              : "text-slate-400 dark:text-slate-500 hover:bg-black/5 dark:hover:bg-white/5 hover:text-slate-800 dark:hover:text-slate-200"
          }`}
          key={item.id}
          onClick={() => onNavigate(item.id)}
          type="button"
          data-oid="_1df:fk"
        >
          <span
            className="material-symbols-outlined text-[1.1rem]"
            data-oid="zax:akm"
          >
            {item.icon}
          </span>
          <span data-oid="x91lc9:">{item.label}</span>
        </button>
      ))}
    </nav>
  );
}
